module.exports = __webpack_public_path__ + "media/man6.6b87e9b5.wav";